import * as THREE from 'three'
import type { MeshAppearance } from '@/plugins/mesh/types'

/** 创建独立外观材质，源材质和纹理仍由资产所有者管理。 */
export function createMeshAppearanceMaterial(
  geometry: THREE.BufferGeometry,
  sourceMaterial: THREE.Material,
  appearance: MeshAppearance
): THREE.Material {
  const material =
    appearance.mode === 'solidColor'
      ? sourceMaterial instanceof THREE.MeshBasicMaterial || !geometry.getAttribute('normal')
        ? new THREE.MeshBasicMaterial({ color: appearance.color, side: sourceMaterial.side })
        : new THREE.MeshStandardMaterial({
            color: appearance.color,
            side: sourceMaterial.side,
            roughness: 0.8,
            metalness: 0,
          })
      : sourceMaterial.clone()
  const source = appearance.mode === 'source' ? sourceMaterial : undefined
  const opacity = (source?.opacity ?? 1) * THREE.MathUtils.clamp(appearance.opacity, 0, 1)
  material.opacity = opacity
  material.transparent = opacity < 1 || source?.transparent === true
  material.depthWrite = opacity < 1 ? false : (source?.depthWrite ?? true)
  if ('wireframe' in material) material.wireframe = appearance.wireframe
  material.needsUpdate = true
  return material
}
